import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {CustomerService} from "./services/customer.service";
import {connect} from 'react-redux';
import {setError} from "../redux/user/actions"

class PasswordReset extends Component {
    constructor(props){
        super(props);
        this.state = {
            oldPassword: '',
            newPassword: '',
            valid: false,
            redirect: false

        }
    }

    useQuery() {
      return new URLSearchParams(window.location.search);
    }

    validatePassword = (password) => {
        password = password.target.value;
        if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/.test(password)) {
            this.setState({valid: false, newPassword: ''});
            this.props.setError("Password should contain at least one upper case, one lower case, one numeric character and be at least 8 characters long");

        }

    }

    getToken() {
        let query = this.useQuery();
        this.state.resetToken = query.get("token");
        return query.get("token");
        // return "";
    }

    componentWillUnmount() {
        this.props.setError('');
    }

    submitForm = (e) => {
        e.preventDefault();

        let customer = new CustomerService();
        customer.resetPassword(this.state.email,this.state.newPassword, this.state.resetToken)
        .then( res => {
            if (!!res) {
                this.setState({redirect:true});
            }

        })
    }

    renderRedirect = () => {
        if (this.state.redirect) {
          return <Redirect to='/account' />
        }
      }

    render() {
        const {
            email,
            newPassword,
            resetToken
        } = this.state;

        return(<form onSubmit={this.submitForm} className="register__form">
            {this.renderRedirect()}
        <input
            type="email"
            className="input register__input"
            onChange={(e) => this.setState({
                email: e.target.value
            })}
            placeholder="Enter your email"
            value={email}
            required
        />
        <input
            type="password"
            className="input register__input"
            onChange={(e) => this.setState({
                newPassword: e.target.value
            })
            }
            onBlur={this.validatePassword}
            placeholder="Enter New Password"
            value={newPassword}
            required
        />
        <input
            type="hidden"
            className="input register__input"
            onChange={(e) => this.setState({
                resetToken: e.target.value
            })}
            value={this.getToken()}
            required
        />
        <button type="submit" className="btn register__submit">
            Submit
        </button>
    </form>)
    }

}

const mapStateToProps = state => ({
    error: state.user.error
});

const mapDispatchToProps ={
    setError
};


export default connect(mapStateToProps,mapDispatchToProps)(PasswordReset);
